import { type ReactNode } from "react";
import { useLocation } from "@/lib/router-compat";
import { useToolsConfig } from "@/hooks/useToolsConfig";
import { TOOLS } from "@/config/toolsRegistry";

/**
 * Blocks access to pages that have been disabled in the admin panel.
 * Renders the 404 page instead of the route content.
 */
const DisabledPageGate = ({ children, notFound }: { children: ReactNode; notFound: ReactNode }) => {
  const location = useLocation();
  const { config, loading } = useToolsConfig();

  const path = location.pathname.replace(/\/+$/, "") || "/";
  const tool = TOOLS.find((t) => path === t.path || path.startsWith(`${t.path}/`));

  if (!tool) return <>{children}</>;
  if (loading) return <div className="min-h-dvh bg-background" />;
  if (config[tool.id]?.enabled === false) return <>{notFound}</>;

  return <>{children}</>;
};

export default DisabledPageGate;
